import React from 'react';

import WBSlateReduxBridge from '../../components/Slate/WBSlateReduxBridge';
import {RunQueryContext} from '../../state/runs/context';
import {useLoadedReportContext} from './LoadedReportContext';
import {useReportPageContext} from './ReportPageContext';
import {ReportMode} from './types';

export const ReportPageContent = () => {
  const {projectName, entityName, reportMode, viewedReportId} =
    useReportPageContext();
  const {reportViewRef, view} = useLoadedReportContext();

  return (
    <RunQueryContext.Provider
      value={{
        entityName,
        projectName,
        report: {id: viewedReportId},
      }}>
      <WBSlateReduxBridge
        entityName={entityName}
        projectName={projectName ?? ''}
        viewId={viewedReportId}
        readOnly={reportMode === ReportMode.IS_VIEWING}
        viewRef={reportViewRef}
        view={view}
      />
    </RunQueryContext.Provider>
  );
};
